import { FieldEnum, FieldTypeEnum, SelectedFieldEnum } from './fields.dto'
import { Field } from './fields';
import { createDefaultRecipientRoleFieldBase } from './default-recipient-role-field';

const withCalculation = (field: Field) => ({
  enable_calculation: field.enable_calculation ?? 0,
  connected_parent_calculation_id: field.connected_parent_calculation_id ?? [],
  eval_calculation: field.eval_calculation ?? "",
  const_eval_calculation: field.const_eval_calculation ?? "",
  calculation_decimal: field.calculation_decimal ?? "",
});

export const Textfield = {
    tag(field) {
        return {
            ...createDefaultRecipientRoleFieldBase(field, true),
            field_name: "Text Field",
            field: FieldEnum.TextField,
            type: FieldTypeEnum.Text,
            selected_field: SelectedFieldEnum.TextField,
            is_locked: field.is_locked ?? 0,
            ...withCalculation(field),
            content_library_selected_field_type: field.content_library_selected_field_type ?? "",
            content_library_selected_role: field.content_library_selected_role ?? "",
        }
    }
}
